import { fabric } from 'fabric';

function generateUUID() {
  var d = new Date().getTime();
  var uuid = 'xxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
  return uuid;
}

function getObjectByUUID(container, uuid) {
  let object = null;
  let objects = container.getObjects();
  for (var i = 0, len = container.size(); i < len; i += 1) {
    if (objects[i].uuid && objects[i].uuid === uuid) {
      object = objects[i];
      break;
    }
  }

  return object;
}

function isElementInFullscreen() {
  const fullscreenElement =
    document.fullscreenElement || document.webkitFullscreenElement || document.mozFullscreenElement;
  return fullscreenElement;
}

function setObjectCanSelect(container, value) {
  // let objects = container.getObjects();
  // let len = container.size();
  // for (var i = 0; i < len; i++) {
  //     if (objects[i]) {
  //         objects[i].selectable = value;
  //     }
  // }
  container.forEachObject(o => {
    o.selectable = value;
  });
  container.renderAll();
}

function setObjectDefaultControlOption(container, option, app) {
  let store = app.store;
  const mouseEnable = store.getKV('mouseEnable') || false;
  container.forEachObject(o => {
    // Object.keys(option).every(v => {
    //   o[v] = option[v];
    //   return true;
    // });
    Object.assign(o, option);
    o.selectable = mouseEnable;
  });
  container.renderAll();
}
fabric.Object.prototype.toObject = (function (toObject) {
  return function (propertiesToInclude) {
    propertiesToInclude = (propertiesToInclude || []).concat(['uuid', 'gtype', 'pageId']);
    return toObject.apply(this, [propertiesToInclude]);
  };
})(fabric.Object.prototype.toObject);

const _original_initHiddenTextarea = fabric.IText.prototype.initHiddenTextarea;
fabric.util.object.extend(fabric.IText.prototype, {
  // fix for : IText not editable when canvas is in a fullscreen element on chrome
  // https://github.com/fabricjs/fabric.js/issues/5126
  initHiddenTextarea: function () {
    _original_initHiddenTextarea.call(this);
    if (isElementInFullscreen()) {
      // in a fullscreen element on chrome
      // fontSize设置为0是为了解决 textarea 标签 占据空间导致文本换行、多行操作、在画板边缘点击文本会导致 画布跳动。也可以设置width,height等属性解决。
      this.hiddenTextarea.style.fontSize = '0px';
      this.canvas.wrapperEl.appendChild(this.hiddenTextarea);
    }
  }
});
// module.exports.generateUUID = generateUUID;
// module.exports.getObjectByUUID = getObjectByUUID;
// module.exports.setObjectCanSelect = setObjectCanSelect;
// module.exports.setObjectDefaultControlOption = setObjectDefaultControlOption;

function debounce(func, delay) {
  let timer = null;
  return function () {
    const context = this;
    const args = arguments;
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(context, args);
    }, delay);
  };
}

export {
  generateUUID,
  getObjectByUUID,
  setObjectCanSelect,
  setObjectDefaultControlOption,
  debounce,
  isElementInFullscreen
};
